import styled from 'styled-components'

export const FullContainer = styled.div`
  width: 100%;
  height: calc(100% - 40px);
  position: absolute;
  inset: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const InnerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BorderBox = styled.div`
  position: relative;
  width: 70%;
  aspect-ratio: 1 / 1;
  border-radius: 0.5rem;
`

export const Corner = styled.div<{ $position: string; $borderColor: string }>`
  position: absolute;
  width: 15%;
  height: 7%;
  border: 4px solid ${({ $borderColor }) => $borderColor};
  border-radius: 0.1rem;

  ${({ $position }) =>
    $position === 'top-left' &&
    `
    top: 0;
    left: 0;
    border-bottom-color: transparent;
    border-right-color: transparent;
    border-top-left-radius: 0.5rem;
  `}

  ${({ $position }) =>
    $position === 'top-right' &&
    `
    top: 0;
    right: 0;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-top-right-radius: 0.5rem;
  `}

  ${({ $position }) =>
    $position === 'bottom-left' &&
    `
    bottom: 0;
    left: 0;
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-left-radius: 0.5rem;
  `}

  ${({ $position }) =>
    $position === 'bottom-right' &&
    `
    bottom: 0;
    right: 0;
    border-top-color: transparent;
    border-left-color: transparent;
    border-bottom-right-radius: 0.5rem;
  `}
`
